import React,{useContext, useCallback} from "react"
import ImportReportButton from "../Forms/ImportReportButton";
import { GlobalStoreContext } from 'js/Context/UseGlobalStoreContext';

const ImportReport = ({reportId,personSession,setLoading,disableLoading}) => {
    const {reportItem:report,loadReportItem} = useContext(GlobalStoreContext);

    const reloadReport = useCallback(()=>{
        loadReportItem(personSession.session.id,false,reportId)
    },[reportId,personSession])

    return(
    <section className="edit-report-import">
        <ImportReportButton
            reportId={reportId}
            personSession={personSession}
            report={report}
            reloadReport={reloadReport}
            setLoading={setLoading}
            disableLoading={disableLoading}
        />
    </section>
    );
}


export default ImportReport;